module.exports = __webpack_public_path__ + "static/media/nyt-black.b7b70524.png";